export default __webpack_public_path__ + "static/media/add.ca979f4b.svg";